import { useMemo } from "react";
import { useStyles } from "hooks/hooks";
import { MenuItem, ListItemIcon, ListItemText } from "@mui/material";
interface Props {
    filter?: { display: string };
    onClick?: () => void;
    checked?: boolean;
}

const CheckableMenuItem = ({ filter, checked, onClick }: Props) => {
    const classes = useStyles({
        optionItem: {
            whiteSpace: "initial !important",
            minHeight: "40px !important",
            "&:hover": {
                background: "#198CCA0D !important"
            }
        },
        optionItemHeader: {
            width: "204px"
        },
        listItem: {
            height: "auto !important",
            paddingLeft: "0px !important",

            "& .css-10hburv-MuiTypography-root": {
                paddingLeft: "0px !important",
                fontSize: "13px !important",
                fontFamily: "PolySans Median",
                color: "#11131F !important",
                fontWeight: "400 !important"
            }
        }
    });

    const styles = useMemo(() => (checked ? { paddingLeft: "0px" } : {}), [checked]);

    return (
        <MenuItem className={classes.optionItem} onClick={onClick}>
            <ListItemText className={classes.listItem} inset style={styles}>
                {filter.display}
            </ListItemText>
            {checked && (
                <ListItemIcon style={{ minWidth: "22px" }}>
                    <i className="checkmarkIcon" style={{ marginLeft: "13px" }} />
                </ListItemIcon>
            )}
        </MenuItem>
    );
};

export default CheckableMenuItem;
